import { reactive, watch } from 'vue';
import { supabase } from '../supabase';
import ustore from './authStore';

const cartStore = reactive({
    cartData: [],
    refresh: fetchCartData,
    isLoading: false,
});

async function fetchCartData() {
    const userId = ustore.uData.id;
    if (!userId) return;
    cartStore.isLoading = true;

    const { data, error } = await supabase
        .from('cart')
        .select('id, product_id, course (title, price, image_url)')
        .eq('user_id', userId);

    cartStore.isLoading = false;

    if (error) {
        console.error(error);
        return;
    }

    cartStore.cartData = data;
}



watch(ustore, () => {
    fetchCartData();
});

fetchCartData();

export default cartStore;